import { apiClient, handleResponse } from './axios';

async function addNotification(body) {
  try {
    const response = await apiClient.post('/notificationEW', body);
    const notification = await handleResponse(response);
    return notification;
  } catch (error) {
    return error.response;
  }
}

const notificationsServices = {
  addNotification,
};

export default notificationsServices;
